<div *ngIf="customTableFilterData?.length" class="table-filter-container" [class.opened]="filterFormOpened" [class.unstyled]="!hasTableStyles">
    <div class="content">
        <div></div>
        <form *ngIf="filterForm?.value != {} && formControls" [formGroup]="filterForm">
            <div class="filter-dropdowns d-flex align-items-center">
                <ng-container *ngFor="let filterItem of customTableFilterData">
                    <div 
                        *ngIf="filterItem?.options?.length && formControls[filterItem.value]?.value as _groupValues" 
                        [formGroupName]="filterItem.value"
                    >
                        <button 
                            mat-button 
                            class="mx-4" 
                            [matMenuTriggerFor]="filterOptions" 
                            (menuClosed)="submitFilters()"
                        >
                            <div class="d-flex align-items-center justify-content-between">
                                <div 
                                    class="text-truncate" 
                                    style="max-width: 200px;" 
                                    [class.text-hint]="!_groupValues?.options?.length"
                                >{{ 
                                    !_groupValues?.options?.length 
                                        ? _groupValues?.label 
                                        : (_groupValues.showLabelWithSelected ? (_groupValues.label + ': ') : '') 
                                            + (_groupValues?.options[0]?.label 
                                                + ((_groupValues?.options?.length > 1) 
                                                    ? (' (+' + _groupValues?.options?.length + ')') 
                                                    : '' ))
                                }}</div>
                                <mat-icon class="material-icons-outlined text-hint">arrow_drop_down</mat-icon>
                            </div>
                        </button>
    
                        <mat-menu #filterOptions="matMenu" yPosition="below">
                            <div class="filter-form">
                                <div class="mat-body-1 mb-8 px-16">{{_groupValues?.label}}</div>
                                <mat-divider class="ml-16 mr-16 mb-8"></mat-divider>
                                <div [formGroupName]="'options'" class="filter-panel">
                                    <div *ngFor="let filterOpt of filterItem.options; let i=index">
                                        <mat-checkbox 
                                            class="filter-options" 
                                            #checkbox="matCheckbox" 
                                            [checked]="isChecked(filterOpt, filterItem.value)" 
                                            (change)="setCheckBoxValue(filterItem, filterOpt, checkbox)"
                                            (click)="$event.stopPropagation()"
                                            >{{ filterOpt.label }}</mat-checkbox
                                        >
                                    </div>
                                </div>
                                <div class="filter-action d-flex justify-content-end">
                                    <button
                                        *ngIf="hasTableStyles"
                                        mat-button 
                                        type="button" 
                                        (click)="clearGroupValue($event, filterItem.value)" 
                                        [disabled]="!_groupValues?.options?.length"
                                    >
                                        <span [class.text-hint]="false">Clear</span>
                                    </button>
                                    <button mat-button type="button" color="accent" (click)="submitFilters()">Apply</button>
                                </div>
                            </div>
                        </mat-menu>
                    </div>
                </ng-container>

                
                <button 
                    mat-icon-button 
                    (click)="clearAllGroups()"  
                    [disabled]="!hasAnyFilter"
                >
                    <mat-icon 
                        class="material-icons-outlined" 
                        [matTooltip]="'Clear and dismiss filters'" 
                        [matTooltipShowDelay]="tooltipDelay" 
                        [class.text-hint]="hasAnyFilter"
                    >close</mat-icon>
                </button>
            </div>
        </form>
    </div>
</div>
